import { useState, type FormEvent } from 'react';
import { ShopError, api } from '../api';
import { readConsent } from '../tracking/consent';
import { getVisitorId } from '../tracking/ids';

/**
 * Přihlášení k newsletteru v patičce.
 *
 * Sbírá jen e-mail; potvrzení i případnou duplicitu řekne na místě. Odesílání
 * kampaní řeší marketing mimo systém – tady je jen čistý, odhlásitelný sběr.
 */
export function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');
  const [message, setMessage] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (status === 'sending') return;

    const trimmed = email.trim();
    if (trimmed === '') {
      setStatus('error');
      setMessage('Zadej prosím e-mail.');
      return;
    }

    setStatus('sending');
    try {
      // CDP: visitor id jde s prihlasenim jen pri souhlasu s analytikou –
      // samotny newsletter je samostatny souhlas a funguje i bez nej.
      const result = await api.subscribeNewsletter(
        trimmed,
        readConsent().analytics ? getVisitorId() : undefined,
      );
      setStatus('done');
      setMessage(
        result.duplicate
          ? 'Tenhle e-mail už novinky odebírá.'
          : 'Hotovo! Novinky a akce ti budeme posílat.',
      );
    } catch (error) {
      setStatus('error');
      setMessage(
        error instanceof ShopError
          ? error.message
          : 'Nepodařilo se přihlásit. Zkus to prosím za chvíli.',
      );
    }
  }

  return (
    <div className="footer-news">
      <strong className="footer-news-title">Novinky a akce e-mailem</strong>
      {status === 'done' ? (
        <p className="footer-news-done" role="status">
          {message}
        </p>
      ) : (
        <>
          <form className="footer-news-form" onSubmit={submit} noValidate>
            <input
              type="email"
              className="footer-news-input"
              placeholder="vas@email.cz"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
                if (status === 'error') setStatus('idle');
              }}
              aria-label="E-mail pro odběr novinek"
              autoComplete="email"
            />
            <button type="submit" className="button primary" disabled={status === 'sending'}>
              {status === 'sending' ? 'Přihlašuji…' : 'Odebírat'}
            </button>
          </form>
          {status === 'error' && <p className="footer-news-error">{message}</p>}
          <p className="muted small">Kdykoli se lze odhlásit. Žádný spam.</p>
        </>
      )}
    </div>
  );
}
